import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'

export const Route = createFileRoute('/_panel/zadania/aktywnosci/harmonogram')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    if (me.status === 200 && me.data.role !== 'admin' && me.data.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
    throw redirect({ to: '/punktacja' })
  },
})
